var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarceline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_382",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29252",
    "data-name": "Group 29252",
    transform: "translate(360 10935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -360, -10935)",
    filter: "url(#Ellipse_382)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_382-2",
    "data-name": "Ellipse 382",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50153",
    "data-name": "Path 50153",
    d: "M33.939,24.079a69.151,69.151,0,0,1-.528,7.52c-.093.877-.178,1.715-.248,2.515a.783.783,0,0,1-.776.706h-24a.777.777,0,0,1-.574-.256.768.768,0,0,1-.194-.6c.023-.241.031-.458.031-.66a48.583,48.583,0,0,0-.916-7.644A36.735,36.735,0,0,1,6,20.02C6,13.462,9.523,7.9,14.258,6.873A7.9,7.9,0,0,1,21.2,3a10.641,10.641,0,0,1,8.49,4.781C32.387,11.948,33.939,17.893,33.939,24.079Z",
    transform: "translate(-343 -10920)",
    fill: "#151a43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50154",
    "data-name": "Path 50154",
    d: "M29.738,39.1H16.42c.636-2.646,2-3.1,2-3.1h9.313S29.1,36.458,29.738,39.1Z",
    transform: "translate(-345.333 -10927.389)",
    fill: "#b71c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50155",
    "data-name": "Path 50155",
    d: "M29.97,43.1H16a13.387,13.387,0,0,1,.326-3.1H29.644A13.388,13.388,0,0,1,29.97,43.1Z",
    transform: "translate(-345.239 -10928.285)",
    fill: "#821616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50156",
    "data-name": "Path 50156",
    d: "M28.641,21.507c0,2.716-3.1,3.392-3.1,6.108,0,1.824.776,2.235,2.328,3.011l-4.657,3.1-4.657-3.1c1.552-.776,2.328-1.3,2.328-3.011,0-2.716-3.88-2.91-3.88-6.3,0-2.041,3.1-6.6,3.1-9.313l8.537,9.313Z",
    transform: "translate(-345.463 -10922.016)",
    fill: "#bbdefb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50157",
    "data-name": "Path 50157",
    d: "M20.776,20a.776.776,0,1,0,.776.776A.776.776,0,0,0,20.776,20Zm4.657,0a.776.776,0,1,0,.776.776A.776.776,0,0,0,25.433,20Zm-.388,10.089a.388.388,0,1,0,.388.388A.388.388,0,0,0,25.045,30.089Zm0,1.552a.388.388,0,1,0,.388.388A.388.388,0,0,0,25.045,31.641Zm-.39-8.9A4.022,4.022,0,0,1,23.1,23.1a4.03,4.03,0,0,1-1.552-.369V23.1h0v1.552l.677-1.016a1.715,1.715,0,0,0,1.749,0l.677,1.016V23.1h0Z",
    transform: "translate(-346.135 -10923.807)",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarceline);
export default __webpack_public_path__ + "static/media/marceline.4a947866880bb4e45e98b2c40d11306f.svg";
export { ForwardRef as ReactComponent };